import { z } from 'zod';
import { ResumeQualityScoreRubric } from 'libs/end-to-end/src/types/resume-parser/resume-quality-score-rubric';

export const AllowedOpenAiModels = z.enum([
  'gpt-4',
  'gpt-4o',
  'gpt-4o-mini',
  'gpt-4.1-mini',
]);

export type AllowedOpenAiModels = z.infer<typeof AllowedOpenAiModels>;

export const ResumeQualityScoreConfig = z.object({
  resumeQualityScoreEnabled: z.boolean().optional(),
  resumeQualityScoreRubrics: z.array(ResumeQualityScoreRubric).optional(),
  resumeQualityScoreUpdatedAt: z.number().optional(),
  openAiModel: AllowedOpenAiModels.default('gpt-4o-mini'),
});

export type ResumeQualityScoreConfig = z.infer<typeof ResumeQualityScoreConfig>;
